import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import productApiService from './../../services/api/ProductApiService';
import { mapGetters } from 'vuex';
export default {
  name: 'Input',
  data: function data() {
    return {
      subCategoryClone: _objectSpread({}, this.value),
      subCategory: this.value,
      category: this.activeCategory,
      Blob: window.Blob
    };
  },
  mounted: function mounted() {
    if (this.createMode) this.subCategoryClone = _objectSpread(_objectSpread({}, this.value), {}, {
      available: true
    });
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: 'profile/currentProvider'
  })),
  methods: {
    checkLevel: function checkLevel() {
      return this.category.subCategories ? this.category.subCategories[this.category.subCategories.length - 1] ? +this.category.subCategories[this.category.subCategories.length - 1].level + 1 : 1 : 1;
    },
    sendRequest: function sendRequest() {
      var _this = this;

      var subCategory = _objectSpread({}, this.subCategoryClone);

      if (this.createMode) subCategory.level = this.checkLevel();

      if (!subCategory.title) {
        this.$vs.notify({
          text: 'لطفا تمامی فیلد ها را وارد کنید',
          color: 'danger',
          position: 'bottom-center'
        });
        return;
      }

      this.$vs.loading();
      productApiService.createOrEditCategory(this.currentProvider.id, subCategory.id, subCategory, this.category.id).then(function (result) {
        _this.$emit('close');

        _this.$emit(_this.createMode ? 'subCategoryAdded' : 'subCategoryUpdated', result.resource, _this.category);

        _this.$vs.notify({
          text: 'عملیات با موفقیت انجام شد.',
          color: 'success',
          position: 'bottom-center'
        });
      }).catch(function (err) {
        _this.$vs.notify({
          text: err.getErrorDescriptions(),
          color: 'danger',
          position: 'bottom-center'
        });
      }).finally(function () {
        _this.$vs.loading.close();
      });
    }
  },
  watch: {
    subCategory: function subCategory(selectedCategory) {
      if (!this.createMode) {
        this.subCategoryClone = _objectSpread({}, selectedCategory);
      }
    }
  },
  props: {
    value: {
      type: Object
    },
    categories: {
      type: Array,
      required: true
    },
    createMode: {
      tyoe: Boolean,
      default: false
    },
    activeCategory: {
      type: Object
    }
  }
};